import {createEvent} from "effector";

export const setCuratorsStartDataEv = createEvent()
